<template>
    <v-card>                
        <v-toolbar flat color="primary" class="white--text">
            <v-toolbar-title>Notification Subscribers</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-layout wrap>
            <v-flex xs12 sm3 offset-sm1>
                <v-text-field v-model="search" append-icon="search" label="Filter" single-line hide-details></v-text-field>
            </v-flex>
            <v-flex xs12 sm3 offset-sm1>
                <v-checkbox class="active-checkbox" label="Active Only" v-model="activeOnly" hide-details></v-checkbox>
            </v-flex>
            <v-flex xs12 sm2 offset-sm1>
                <v-btn color="primary" block @click="openEdit({ IsActive: true })">
                    Add
                </v-btn>
            </v-flex>
        </v-layout>
        <v-layout pt-3>
            <v-flex xs12>
                <v-data-table
                    :headers="headers"
                    :rows-per-page-items="rowsPerPageItems" 
                    :pagination.sync="pagination"
                    :search="search"
                    :loading="loading"
                    :items="dataFiltered">
                    <template v-slot:items="{ item }">                        
                        <td>{{ item.FirstName }}</td>
                        <td>{{ item.LastName }}</td>
                        <td>{{ item.Email }}</td>
                        <td>
                            <v-chip 
                                v-for="(notification, index) in item.NotificationTypeSubscriber"
                                :key="`${item.PlantNotificationSubscriberID}-${index}`">{{ types[notification.NotificationTypeID - 1].NotificationTypeName }}</v-chip>
                        </td>
                        <td>{{ item.IsActive ? 'Yes' : 'No' }}</td>
                        <td>
                            <v-btn 
                                color="primary"
                                block 
                                @click="openEdit(item)">
                                <span>Edit</span>
                            </v-btn>
                        </td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-card>
</template>
<script>
export default {
    props: {
        data: {
            type: Array,
            required: true
        },
        types: {
            type: Array,
            required: true
        }
    },
    data() {
        return {            
            loading: false,
            search: '',
            activeOnly: true,
            rowsPerPageItems: [10, 25, 50, 100],            
            pagination: {
                page: 1,
                rowsPerPage: 25,
                descending: false
            },
            headers: [
                {
                    text: "First Name",
                    value: "FirstName",
                    sortable: true
                },
                {
                    text: "Last Name",
                    value: "LastName",
                    sortable: true
                },
                {
                    text: "Email",
                    value: "Email",
                    sortable: true
                },
                {
                    text: "Notification Type",
                    value: "NotificationTypeSubscriber",
                    sortable: false,
                },
                {
                    text: "Active",
                    value: "IsActive",
                    sortable: true
                },
                {
                    text: "Edit",
                    value: "",
                    sortable: false
                }
            ]
        }
    },
    computed: {
        dataFiltered() {
            return this.data.filter(d => d.IsActive || !this.activeOnly);
        }
    },
    methods: {
        openEdit(item) {
            this.$emit("edit", item);
        }
    }
}
</script>